<template>
  <div>
    <web-header :searchStatus="$route.query.moduleId"></web-header>
    <Breadcrumb
      :crumbTitle="crumbTitle"
      :crumbName="crumbName"
      :location="crumbTitle+' > '+location"
    ></Breadcrumb>
    <div class="navs">
      <div class="nav-box">
        <ul>
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="{active:liStatus==item.cate_id}"
            @click="getStyle(item.cate_id,item)"
          >{{item.title}}</li>
        </ul>
      </div>
      <div class="nav-box" v-if="model=='photos'">
        新闻标题：<el-input placeholder="请输入要搜索的关键词" style="width:200px" v-model="search.title" clearable></el-input>
        <el-button type="primary" @click="$refs.newsList.handleSearch()" style="background-color:#e83a16;border-color:#e83a16" icon="el-icon-search">搜索</el-button>
      </div>
    </div>
    <WtDataList
      v-model="data.list"
      :url="$url.news.list"
      :pageSize="15"
      :search="search"
      ref="newsList"
    >
      <div slot="list">
        <div class="app-news" v-if="model=='news'">
          <!-- 最新动态组件 -->
          <div class="news">
            <div class="news-box" v-for="(item,index) in data.list" :key="index">
              <router-link
                :to="{ name: 'newsInfo',query: { id: item.id,moduleId:$route.query.moduleId }}"
                target="_blank"
              >
                <div class="img-box" v-if="item.cover_photo">
                  <img :src="item.cover_photo_text[0].path" />
                  <template v-if="item.type == 3">
                    <span class="video-btn"></span>
                  </template>
                  <template v-else-if="item.type == 2">
                    <span class="pic-num">{{item.subsidiary_files.length}}图</span>
                  </template>
                </div>
                <div class="conetnt-box">
                  <h3>{{item.title}}</h3>
                  <p>{{item.description}}</p>
                </div>
                <div class="time">
                  <div class="time-box">
                    <h2>{{getDate(item.publish_time,'MD')}}</h2>
                    <p>{{getDate(item.publish_time,'Y')}}</p>
                  </div>
                  <div class="more-box">
                    <i></i>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <div v-else-if="model=='yuebao'">
          <div class="news">
            <ul class="mreport_list">
              <li v-for="(item,index) in data.list" :key="index">
                <router-link
                  :to="{name:'newsInfo',query:{id:item.id,moduleId:$route.query.moduleId}}"
                  target="_blank"
                >
                  <span class="mreport_box">
                    <img :src="item.cover_photo_text[0].path" v-if="item.cover_photo" />
                  </span>
                  <p>{{item.title}}</p>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div v-else-if="model=='photos'">
          <div class="video">
            <div class="video-box" v-for="(item,index) in data.list" :key="index">
              <router-link
                :to="{name:'newsInfo',query:{id:item.id,moduleId:$route.query.moduleId}}"
                target="_blank"
              >
                <div class="img-box">
                  <img :src="item.cover_photo_text[0].path" v-if="item.cover_photo" />
                </div>
                <div class="title-box">
                  <h5>{{item.title}}</h5>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </WtDataList>
    <WtFooter></WtFooter>
  </div>
</template>
<script>
import webHeader from "../Public/header";
import Breadcrumb from "../Public/breadcrumb";
export default {
  components: {
    webHeader,
    Breadcrumb
  },
  data() {
    return {
      data: {},
      model: "news",
      liStatus: this.$route.query.cate_id,
      search: {
        cate_id: this.$route.query.cate_id
      },
      navList: [],
      crumbTitle: "",
      crumbName: "News",
      location: ""
    };
  },
  methods: {
    getStyle(id, item) {
      this.liStatus = id;
      this.model = item.model;
      this.search.cate_id = item.cate_id;
      this.location = item.title;
      this.$refs.newsList.handleSearch();
    },
    getDate(date, format = "M") {
      switch (format) {
        case "Y": {
          return date.substring(0, 4);
          break;
        }
        case "M": {
          return date.substring(5, 7);
          break;
        }
        case "D": {
          return date.substring(8, 10);
          break;
        }
        default: {
          return date.substring(5, 10);
          break;
        }
      }
    }
  },
  mounted() {
    let params = {
      pid: this.$route.query.moduleId
    };
    this.$db.post(this.$url.website.channel.list, params).then(resp => {
      this.navList = resp.data;
      this.location = resp.data[0].title;
      let p = {
        id: this.$route.query.moduleId
      };
      this.$db.post(this.$url.website.channel.url, p).then(resp => {
        this.crumbTitle = resp.data.title;
        this.crumbName = resp.data.short;
        this.model = resp.data.model;
        this.model = this.$route.query.model
          ? this.$route.query.model
          : this.model;
      });
    });
  },
  watch: {
    $route(to, form) {
      this.$router.go(0);
    }
  }
};
</script>
<style lang="scss" scoped>
#app-news {
  width: 100%;
}
.news {
  max-width: 1300px;
  margin: 50px auto;
  padding-left: 8px;
  .news-box {
    position: relative;
    padding-right: 191px;
    margin-bottom: 30px;
    transition: linear 0.6s;
    cursor: pointer;
    border-radius: 6px;
    overflow: hidden;
    &:hover {
      background-color: #e83a16;
      > a {
        .conetnt-box {
          > h3 {
            color: #fff;
          }
          > p {
            color: #ffc5b9;
          }
        }
        .time {
          .time-box {
            display: none;
          }
          .more-box {
            display: block;
          }
        }
      }
    }
    > a {
      display: block;
      display: flex;
      .img-box {
        width: 300px;
        //@errorheight: 160px;
        margin-right: 16px;
        > img {
          max-width: 300px;
          //height: 100%;
        }
      }
      .conetnt-box {
        padding-left: 30px;
        padding-right: 72px;

        > h3 {
          font-size: 18px;
          color: #333333;
          margin-top: 25px;
        }
        > p {
          font-size: 16px;
          line-height: 30px;
          color: #999999;
          margin: 20px 0;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
      .time {
        width: 190px;
        height: calc(100% - 30px);
        margin: 15px 0;
        border-left: 1px solid #eee;
        position: absolute;
        top: 0;
        right: 0;
        .time-box {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          transition: linear 0.6s;
          display: block;
          > h2 {
            font-size: 30px;
            font-weight: normal;
            color: #999;
            text-align: center;
          }
          > p {
            font-size: 14px;
            color: #999;
          }
        }
        .more-box {
          width: 25px;
          height: 25px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: url(../../assets/images/more2.png) no-repeat;
          background-size: 100% 100%;
          display: none;
          transition: linear 0.6s;
        }
      }
    }
  }
}
.page-box {
  max-width: 1300px;
  margin: 0 auto;
  margin-bottom: 50px;
  text-align: center;
}
.page-box /deep/ .el-pagination.is-background .btn-prev {
  background-color: #fff;
  border: solid 1px #cccccc;
  border-radius: 50%;
}
.page-box /deep/ .el-pagination.is-background .btn-next {
  background-color: #fff;
  border: solid 1px #cccccc;
  border-radius: 50%;
}
.page-box /deep/ .el-pagination.is-background .el-pager li {
  border-radius: 50%;
  background-color: #fff;
  border: solid 1px #cccccc;
}
.page-box
  /deep/
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #e83a16;
  border: solid 1px #e83a16;
}

.video-btn {
  display: block;
  position: absolute;
  left: -77%;
  top: 0;
  bottom: 0;
  right: 0;
  background: url(https://s3.pstatp.com/growth/mobile_list/image/playicon_video@3x_dcf536ff.png)
    no-repeat center center;
  background-size: 50px;
}

.pic-num {
  position: absolute;
  left: 8px;
  bottom: 7px;
  padding: 0 6px;
  height: 20px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  color: #fafafa;
  font-size: 14px;
  text-align: center;
  line-height: 20px;
}
.navs {
  width: 100%;
  background-color: #fff;
  .nav-box {
    max-width: 1300px;
    margin: 30px auto;
    > ul {
      display: flex;
      > li {
        list-style: none;
        padding: 8px 22px;
        border-radius: 19px;
        border: solid 1px #ddd;
        font-size: 16px;
        color: #333;
        margin-right: 18px;
        cursor: pointer;
        &.active {
          background-color: #e83a16;
          border-color: #e83a16;
          color: #fff;
        }
      }
    }
  }
}
ul.mreport_list {
  display: flex;
  flex-wrap: wrap;
}
ul.mreport_list li {
  padding: 5px;
  background-color: #fff;
  width: 18%;
  margin-right: 15px;
  margin-bottom: 50px;
}
ul.mreport_list li span.mreport_box {
  overflow: hidden;
  background-color: #f5f5f5;
}
ul.mreport_list li span.mreport_box img {
  max-width: 100%;
  border: 1px solid #dfdfdf;
}
ul.mreport_list li p {
  text-align: center;
}
ul.mreport_list li a {
  color: #333;
}
.video {
  max-width: 1300px;
  margin: 50px auto;
  display: flex;
  // justify-content: space-between;
  flex-wrap: wrap;
  .video-box {
    position: relative;
    margin-bottom: 52px;
    margin-right: 50px;
    cursor: pointer;
    &:nth-child(3n) {
      margin-right: 0;
    }
    &:hover {
      .title-box {
        > p {
          background-color: #f34e2c;
        }
        > h5 {
          background-color: #e83a16;
          color: #fff;
        }
      }
      .mask-box {
        display: block;
      }
    }
    .img-box {
      width: 400px;
      height: 280px;
      > img {
        width: 100%;
        height: 100%;
      }
    }
    .mask-box {
      width: 400px;
      height: 280px;
      background-color: rgba($color: #000000, $alpha: 0.3);
      position: absolute;
      top: 0;
      left: 0;
      display: none;
      transition: linear 0.6s;
      > h3 {
        font-size: 100px;
        font-weight: 100;
        color: #fff;
        text-align: center;
        line-height: 280px;
      }
    }

    .title-box {
      // position: absolute;
      // left: 0;
      // bottom: 0;
      display: flex;
      > h5 {
        width: 100%;
        height: 60px;
        background-color: #f5f5f5;
        // padding-left: 35px;
        line-height: 60px;
        font-weight: normal;
        font-size: 16px;
        color: #333;
        transition: linear 0.6s;
        text-align: center;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/News/list.vue